import api from "./Api";

class CepService {
  GetCep(payload) {
    return api.get("/v1/cep/" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CepService();
